module.exports = __webpack_public_path__ + "static/media/logo-barracuda-dark.faebd37b.svg";